__webpack_require__.p = "/video-diagnostics/";